import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';

export const GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY = '@birthday-message/get-birthday-message-sending-strategy';
export const GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY_SUCCESS = '@birthday-message/get-birthday-message-sending-strategy-success';
export const GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY_ERROR = '@birthday-message/get-birthday-message-sending-strategy-error';

export const GET_BIRTHDAY_MESSAGE_SETTINGS = '@birthday-message/get-birthday-message-settings';
export const GET_BIRTHDAY_MESSAGE_SETTINGS_SUCCESS = '@birthday-message/get-birthday-message-settings-success';
export const GET_BIRTHDAY_MESSAGE_SETTINGS_ERROR = '@birthday-message/get-birthday-message-settings-error';

export const UPDATE_BIRTHDAY_MESSAGE_SETTINGS = '@birthday-message/update-birthday-message-settings';
export const UPDATE_BIRTHDAY_MESSAGE_SETTINGS_SUCCESS = '@birthday-message/update-birthday-message-settings-success';
export const UPDATE_BIRTHDAY_MESSAGE_SETTINGS_ERROR = '@birthday-message/update-birthday-message-settings-error';

export const getBirthdayMessageSendingStrategy = () => async (dispatch) => {
  dispatch({
    type: GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY,
  });
  try {
    const response = await axios.get('/api/contact-settings/birthday-message-sending-strategy');
    dispatch({
      type: GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY_ERROR,
    });
  }
};

export const getBirthdayMessageSettings = () => async (dispatch) => {
  dispatch({
    type: GET_BIRTHDAY_MESSAGE_SETTINGS,
  });
  try {
    const response = await axios.get('/api/contact-settings/birthday-message');
    dispatch({
      type: GET_BIRTHDAY_MESSAGE_SETTINGS_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_BIRTHDAY_MESSAGE_SETTINGS_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_BIRTHDAY_MESSAGE_SETTINGS_ERROR,
    });
  }
};

export const updateBirthdayMessageSettings = (birthdayMessageSettings, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_BIRTHDAY_MESSAGE_SETTINGS,
    });
    const response = await axios.put(
      '/api/contact-settings/birthday-message',
      birthdayMessageSettings || {}
    );

    if (!response?.data?.id) {
      dispatch(addNotification(UPDATE_BIRTHDAY_MESSAGE_SETTINGS_ERROR, 'Can not update contact', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: UPDATE_BIRTHDAY_MESSAGE_SETTINGS_ERROR,
      });
      return;
    }

    dispatch({
      type: UPDATE_BIRTHDAY_MESSAGE_SETTINGS_SUCCESS,
      payload: response?.data || {}
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(
      UPDATE_BIRTHDAY_MESSAGE_SETTINGS_ERROR,
      message || errorMessage || 'Try again later',
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: UPDATE_BIRTHDAY_MESSAGE_SETTINGS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};
